window.onload = function () {
    if (document.querySelector('.news-slider__container')) {
        let containers = document.querySelectorAll('.news-slider__container');

        containers.forEach((slider, index) => {
            var swiper = new Swiper('.news-slider__container', {
                slidesPerView: 2,
                spaceBetween: 20,
                slidesPerGroup: 1,
                loop: true,
                // loopFillGroupWithBlank: true,
                breakpoints: {
                    1000: {
                        slidesPerView: 1,
                    }
                }
            })

            var swiper = slider.swiper;

            slider.querySelector('.news-slider__arrow_prev').addEventListener('click', () => {
                swiper.slidePrev();
            });

            slider.querySelector('.news-slider__arrow_next').addEventListener('click', () => {
                swiper.slideNext();
            });
        })
    }

    if (document.querySelector('.announce-slider__container')) {
        var swiperAnnounce = new Swiper('.announce-slider__container', {
            slidesPerView: 4,
            spaceBetween: 20,
            slidesPerGroup: 1,
            loop: true,
            centerInsufficientSlides: true,
            // loopFillGroupWithBlank: true,
            breakpoints: {
                1150: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 2,
                },
                500: {
                    slidesPerView: 1,
                }
            }
        })

        var swiperAnnounce = document.querySelector('.announce-slider__container').swiper

        document.querySelector('.announce__arrow_prev').addEventListener('click', () => {
            swiperAnnounce.slidePrev();
        })
        document.querySelector('.announce__arrow_next').addEventListener('click', () => {
            swiperAnnounce.slideNext();
        })
    }

    if (document.querySelector('.gallery__container')) {

        var isLoop = true

        var swiperGallery = new Swiper('.gallery__container', {
            navigation: {
                nextEl: '.gallery__arrow_next',
                prevEl: '.gallery__arrow_prev'
            },
            slidesPerView: 4,
            spaceBetween: 20,
            slidesPerGroup: 1,
            loop: isLoop,
            // loopFillGroupWithBlank: true,
            breakpoints: {
                1000: {
                    slidesPerView: 3,
                },
                750: {
                    slidesPerView: 2,
                },
                450: {
                    slidesPerView: 1,
                }
            }
        })

        if ($('.swiper-slide').length < swiperGallery[0].params.slidesPerView) {
            isLoop = false;
        }

        // var swiperGallery = document.querySelector('.gallery__container').swiper

        // document.querySelector('.gallery__arrow_prev').addEventListener('click', () => {
        //     swiperGallery.slidePrev();
        // })
        // document.querySelector('.gallery__arrow_next').addEventListener('click', () => {
        //     swiperGallery.slideNext();
        // })
    }

    if (document.querySelector('.section-slider')) {
        var swiperSlider = new Swiper('.section-slider', {
            slidesPerView: 4,
            spaceBetween: 20,
            slidesPerGroup: 1,
            loop: true,
            // loopFillGroupWithBlank: true,
            breakpoints: {
                1000: {
                    slidesPerView: 3,
                },
                750: {
                    slidesPerView: 2,
                },
                450: {
                    slidesPerView: 1,
                }
            }
        })

        var swiperSlider = document.querySelector('.section-slider').swiper

        document.querySelector('.section-slider__arrow_prev').addEventListener('click', () => {
            swiperSlider.slidePrev();
        })
        document.querySelector('.section-slider__arrow_next').addEventListener('click', () => {
            swiperSlider.slideNext();
        })
    }


    if (document.querySelector('.partners__container')) {
        var swiperPartners = new Swiper('.partners__container', {
            slidesPerView: 6,
            spaceBetween: 30,
            slidesPerGroup: 1,
            loop: true,
            // loopFillGroupWithBlank: true,
            breakpoints: {
                1400: {
                    slidesPerView: 5,
                },
                1200: {
                    slidesPerView: 4,
                },
                1000: {
                    slidesPerView: 3,
                },
                760: {
                    slidesPerView: 2,
                },
                600: {
                    slidesPerView: 1,
                }
            }
        })

        var swiperPartners = document.querySelector('.partners__container').swiper

        document.querySelector('.partners__arrow_prev').addEventListener('click', () => {
            swiperPartners.slidePrev();
        })
        document.querySelector('.partners__arrow_next').addEventListener('click', () => {
            swiperPartners.slideNext();
        })
    }

    if (document.querySelector('.campus-slider__container')) {
        var campusSlider = new Swiper('.campus-slider__container', {
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 1,
            loop: true,
            autoplay: {
                delay: 2000,
            },
            // centerInsufficientSlides: true,
            // loopFillGroupWithBlank: true,
            navigation: {
                nextEl: '.campus-slider__arrow_next',
                prevEl: '.campus-slider__arrow_prev',
            },
        })
    }

    if (document.querySelector('.campus-index-slider__container')) {
        var campusIndexSlider = new Swiper('.campus-index-slider__container', {
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 1,
            loop: true,
            autoplay: {
                delay: 2000,
            },


            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    }
}

